<!-- <app-preloader></app-preloader> -->
<!-- <div class="dark-light-switch-btn" (click)="toggleTheme()" style="cursor: pointer; z-index: 999999;">
    <button type="button">
        <i [class]="isDarkTheme ? 'bx bx-sun' : 'bx bx-moon'"></i>
    </button>
</div> -->
<router-outlet></router-outlet>
<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">
<link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" rel="stylesheet">
<!-- <app-footer *ngIf="!(location == '/auth/login' || location == '/auth/register' || location == '/auth/coming-soon')"></app-footer> -->

<app-coke-popup></app-coke-popup>

<div [class.hidden]="!(loadingService.loading$ | async)" class="loading-overlay">
  <div class="spinner"></div>
</div>